import React, { useState } from "react";

import UserCreationForm from "./UserCreationForm";
import UserLayout from "../component/Layout";


const ViewPage = () => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Manage sidebar state
  

  // Retrieve user from localStorage and parse it
  const loggedInUserRole =  JSON.parse(localStorage.getItem("userRoles")); // Get role or null
  
  const roleOptions = {
    SUPERUSER: ["Super User", "Admin User", "Normal User"],
    ADMINUSER: ["Admin User", "Normal User"],
  };

  return (
<UserLayout>
        {/* Content Area - Takes Remaining Space */}
        <div className={`flex-1 transition-all duration-300 p-4 mt-20  bg-white rounded-[16px] h-auto`}>

            {/* Render different components based on activePage */}
            
              <UserCreationForm
                loggedInUserRole={loggedInUserRole}
                roleOptions={roleOptions}
              />
            

          
          </div>
          </UserLayout>
      // </div></div>
    //</div>
  );
};

export default ViewPage;
